import React, { useEffect } from "react";
import CustomerMainLayout from '../CustomerMainLayout'
import { CheckCircleOutlined } from '@ant-design/icons';
import ENVIRONMENT from '../../../../environments'
import FileConstants from "../../../../FileConstants";
import axios from "axios";

const COMPANY_ID = FileConstants.COMPANY_ID;
const CUSTOMER_USERNAME = FileConstants.CUSTOMER_USERNAME;

const WalmartOauth = () => {
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const authCode = params.get('code');
        const sellerId = params.get('sellerId');

        if (authCode && sellerId) {
            const payload = {
                company_id: COMPANY_ID,
                customer_username: CUSTOMER_USERNAME,
                action: "create_auth",
                auth_code: authCode,
                seller_id: sellerId
            };

            axios.post(ENVIRONMENT.WALMART_AUTH_LAMBDA_HELPER, payload)
                .then((res) => {
                    localStorage.setItem("walmart_authorized", "true");
                })
                .catch((error) => {
                    console.error("Error saving Walmart authorization data", error);
                });
        }
    }, []);

    return (
        <CustomerMainLayout>
            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", padding: "40px", flexDirection: "column" }}>
                <p className="manrope f-24" style={{ color: "green" }}>
                    Authorization Successful <CheckCircleOutlined />
                </p>
                <p className="manrope f-16" style={{ marginTop: "40px" }}>
                    Press the Walmart button on the PDP to upload product content to Walmart
                </p>
                <img
                    style={{ margin: "unset", width: "800px", borderRadius: "8px", filter: "drop-shadow(2px 4px 6px rgba(0,0,0,0.2))" }}
                    className="pdp-image"
                    src={require("../../../../assets/images/walmart-pdp.png")}
                    alt="walmart-pdp"
                />
            </div>
        </CustomerMainLayout>
    );
}

export default WalmartOauth;
